import { useState } from "react";
import SupportsAPI from "../../../api/SupportsAPI";

const useReplyConversation = () => {
	const [loading, setLoading] = useState(false);

	const replyConversation = async (data) => {
		setLoading(true);

		try {
			const result = await SupportsAPI.replyConversation(data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to create ticket:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		replyConversation,
		loading,
	};
};

export default useReplyConversation;
